import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_480: DocMigration = {
  maxSchemaVersion: "0.0.480",
  description: "Migrate numberOfJackStuds equals to 0 to undefined in old settings",
  apply(json: any) {
    const openings = json.openings;

    for (const openingId in openings) {
      const { entityType } = openings[openingId];

      if (entityType === "OPENING") {
        const framing = openings[openingId].framing || {};
        if (framing.hasOwnProperty("numberOfJackStuds") && framing.numberOfJackStuds === 0) {
          delete framing.numberOfJackStuds;
        }
        openings[openingId].framing = framing;
      }
    }

    // add them to the existing wainscoting settings
    for (const settingId in json?.settings) {
      const setting = json.settings[settingId];
      if (setting?.type === "WINDOW_FRAMING_SETTINGS" || setting?.type === "DOOR_FRAMING_SETTINGS") {
        if (setting.hasOwnProperty("numberOfJackStuds") && setting.numberOfJackStuds === 0) {
          delete setting.numberOfJackStuds;
        }
      }
      if (setting?.type === "WINDOW_CATALOG_SETTINGS") {
        const windowTypes = setting.windowTypes;
        for (const windowTypeId in windowTypes) {
          const windowType = windowTypes[windowTypeId];
          const windowFraming = windowType.framing || {};

          if (windowFraming.hasOwnProperty("numberOfJackStuds") && windowFraming.numberOfJackStuds === 0) {
            delete windowFraming.numberOfJackStuds;
          }
          windowType.framing = windowFraming;
        }
      }
      if (setting?.type === "DOOR_CATALOG_SETTINGS") {
        const doorTypes = setting.doorTypes;
        for (const doorTypeId in doorTypes) {
          const doorType = doorTypes[doorTypeId];
          const doorFraming = doorType.framing || {};

          if (doorFraming.hasOwnProperty("numberOfJackStuds") && doorFraming.numberOfJackStuds === 0) {
            delete doorFraming.numberOfJackStuds;
          }
          doorType.framing = doorFraming;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_480;
